export default function SciPy_Study_Plan() {
  return (
    <div>
      <h1>SciPy Study Plan</h1>
    </div>
  );
}
